<template>
  <div>
    <el-dialog title="In-progress courses" :visible.sync="dialogVisible" @close="closeDialog()">
      <el-table :data="courses.data">
        <el-table-column property="course.course_title" label="Course Name" width="350"></el-table-column>
        <el-table-column property="course_completion_status" label="Percentage">
          <template slot-scope="scope">
            <span>{{  Math.round(scope.row.course_completion_status) }}%</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination v-if="courses.total > courses.per_page"
        background
        layout="prev, pager, next"
        @current-change="getCourses"
        :page-size="courses.per_page"
        :pager-count="5"
        :total="courses.total"
        :current-page="courses.current_page"
        class="float-right"
      >
      </el-pagination>
      <br>
    </el-dialog>
  </div>
</template>

<script>
import {LearningReportApi} from '@/services/api'

export default {
  name: 'InProgressCoursesModal',
  data: () => ({
    dialogVisible: false,
    courses: {},
    userId: '',
  }),
  computed: {
    //
  },
  mounted() {
    this.$parent.$on('in-progress-courses', this.handleParentEvent)
  },
  methods: {
    handleParentEvent(userId) {
      this.userId = userId
      this.getCourses(1)
      this.dialogVisible = true
    },
    getCourses(page = 1) {
      this.is_loading = true
      let q = JSON.parse(JSON.stringify(this.$route.query))
      let params = { ...{type: 'in-progress', page: page}, ...q }

      LearningReportApi.studentInProgressCourses(this.userId, params).then(courses => {
        this.courses = courses
      }).catch(error => {
        console.log('error: ', error)
      }).finally(() => {
        this.is_loading = false
      })
    },
    closeDialog() {
      this.courses = {}
    }
  }
}
</script>
